import React from "react";

const BoltSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16.837"
      height="26.938"
      viewBox="0 0 16.837 26.938"
    >
      <path
        id="bolt-solid"
        d="M15.564,8.418H9.492l2.241-6.829A1.268,1.268,0,0,0,10.513,0H2.936A1.265,1.265,0,0,0,1.684,1.094L0,13.722a1.265,1.265,0,0,0,1.252,1.431H7.5L5.072,25.386a1.261,1.261,0,0,0,2.32.921l9.26-15.995A1.26,1.26,0,0,0,15.564,8.418Z"
        transform="translate(0.011)"
        fill="#35e0ce"
      />
    </svg>
  );
};

export default BoltSVG;
